export default __webpack_public_path__ + "static/media/Marshes.3417dcc9.jpg";